(() => {
  function initialize() {
    const form = document.getElementById('heartloop-cart');
    if (!form || form.dataset.approvalReady) return;
    const approval = form.querySelector('[data-artwork-approval]');
    const value = form.querySelector('[data-artwork-approval-value]');
    const error = form.querySelector('[data-approval-error]');
    const checkout = form.querySelector('[name="checkout"]');
    if (!approval || !value || !error || !checkout) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    form.dataset.approvalReady = 'true';
    approval.removeAttribute('name');
    approval.required = false;
    checkout.formNoValidate = true;

    function sync() {
      value.disabled = !approval.checked;
      checkout.disabled = !approval.checked;
      if (approval.checked) {
        error.hidden = true;
        error.textContent = '';
        approval.removeAttribute('aria-invalid');
      }
    }

    function block(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    function validate(event) {
      sync();
      if (!approval.checked) {
        block(event);
        error.textContent = error.dataset.message;
        error.hidden = false;
        approval.setAttribute('aria-invalid', 'true');
        approval.focus();
        return;
      }
      for (const quantity of form.querySelectorAll('input[name="updates[]"]')) {
        if (!quantity.checkValidity()) {
          block(event);
          quantity.reportValidity();
          return;
        }
      }
      value.value = 'Reviewed in cart';
      value.disabled = false;
    }

    approval.addEventListener('change', sync, options);
    window.addEventListener('click', event => {
      if (event.target instanceof Element && event.target.closest('[name="checkout"]') === checkout) {
        validate(event);
      }
    }, { capture: true, signal: controller.signal });
    form.addEventListener('submit', event => {
      if (event.submitter?.name === 'update') {
        sync();
        return;
      }
      validate(event);
    }, { capture: true, signal: controller.signal });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target instanceof Element && event.target.contains(form)) {
        controller.abort();
        delete form.dataset.approvalReady;
      }
    }, options);
    sync();
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
